import { MutationHookOptions, useMutation } from '@apollo/client';

import { UPDATE_GROUP } from './mutations';

export const useUpdateGroup = (options?: MutationHookOptions) => useMutation(UPDATE_GROUP, options);
